import { render, staticRenderFns } from "./tableComponent.vue?vue&type=template&id=fba9722c&scoped=true"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba9722c",
  null
  
)

export default component.exports